import * as React from 'react';
import classnames from 'classnames';
import { toast, ScrollIntoView, Link } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import '@swc/helpers';
import 'lodash/isEmpty';
import '../../types.js';
import { formatError } from '../../Util/format-error.js';
import 'history';
import '@grandvisionhq/graphql';

const EmailSentConfirmation = /*#__PURE__*/ React.forwardRef(({ title , firstParagraph , secondParagraph , thirdParagraph , resendLink , successMessage , className , onResend , email: email1 , error ,  }, ref)=>{
    const replaceEmail = (label, email)=>{
        return label && label.replace('{{email}}', email) || '';
    };
    React.useEffect(()=>{
        if (!error) {
            toast.success(successMessage);
        }
    }, [
        error,
        successMessage
    ]);
    const sendEmail = ()=>{
        onResend({
            email: email1
        });
    };
    const formattedError = formatError(error);
    const errorKey = typeof formattedError === 'string' ? formattedError : formattedError.join(' ');
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('email-sent-confirmation', 'myaccount__section', className),
        ref: ref
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium"
    }, title), formattedError && /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: errorKey
    }, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        className: "alert-m-default"
    }, formattedError)), /*#__PURE__*/ React.createElement(Text, null, replaceEmail(firstParagraph, email1)), /*#__PURE__*/ React.createElement(Text, null, secondParagraph, " ", /*#__PURE__*/ React.createElement(Link, {
        onClick: sendEmail
    }, resendLink), " ", thirdParagraph));
});

export { EmailSentConfirmation as default };
//# sourceMappingURL=EmailSentConfirmation.js.map
